import { PersonIcon } from '@radix-ui/react-icons';
import { cn } from '@/lib/utils';
import {
  SubmitterUser,
  displaySubmitterName,
} from '@/utils/displaySubmitterName';

export function SubmitterByline({
  user,
  userId,
  className,
}: {
  user?: SubmitterUser;
  userId?: string | null;
  className?: string;
}) {
  const { text, title } = displaySubmitterName(user, userId);
  return (
    <div
      data-name="SUBMITTER_BYLINE"
      className={cn(
        'flex min-w-0 items-center gap-1 text-xs text-muted-foreground',
        className,
      )}
      title={title ?? text}
    >
      <PersonIcon className="h-3 w-3 shrink-0" />
      <span className="truncate">by {text}</span>
    </div>
  );
}
